// @ts-nocheck
// Greif UI Kit = line-list
import * as React from "react";

const BookmarkLine: React.FC = () => {
    /* Store Custom Code - Start */
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m7.457 17.68 3.174-2.026.004-.002.153-.09.004-.003a2.53 2.53 0 0 1 2.273-.072l.143.072.005.002.153.09.003.003 3.174 2.026V5.35H7.457zm11.089 2.192c0 .626-.62 1.025-1.15.784l-.007-.003-.09-.05-.007-.004-4.973-3.175a.59.59 0 0 0-.638 0L6.709 20.6l-.006.005-.092.049-.006.003c-.53.241-1.15-.158-1.15-.784V4.868c0-.881.689-1.595 1.538-1.595h10.016c.85 0 1.537.714 1.538 1.595z"
            />
        </svg>
    );
    /* Store Custom Code - End */
};

export default React.memo(BookmarkLine);
